import $ from 'jquery';

// import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

let app = window.app || {};
window.app = app || {};
window.app.modules =  app.modules || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import './shared/common';

import * as numberSpinner from '@elements/number-spinner';
app.modules.numberSpinner = numberSpinner.initInScope;

import * as showIfChecked from './scripts/shop/showIfChecked';
app.modules.showIfChecked = showIfChecked.initInScope;

import * as affix from '@elements/affix';
app.modules.affix = affix.initInScope;

import * as keycard from './scripts/shop/keycard';
app.modules.keycard = keycard.initInScope;

import * as ajaxFormReset from './scripts/ajax-form-reset';
app.ajaxFormReset = ajaxFormReset.init;

import * as renderTemplate from './scripts/renderTemplate';
app.modules.renderTemplate = renderTemplate.initInScope;

import * as dateInput from '@elements/date-input';
app.modules.dateInput = dateInput.initInScope;

import initModulesInScope from "@elements/init-modules-in-scope";
(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);